/** A labelled text field of the shipment address form; every plain one is built the same way. */
import { FormField } from "../../../../../../../../components/form-field/form-field";
import { Input } from "../../../../../../../../components/inputs/input/input";
import { IValidationGroup } from "../../../../../../../../hooks/validation-group/validation-group-hook";

interface IProps {
    label: React.ReactNode;
    value: string | null;
    onChange: (value: string) => void;
    validationGroup: IValidationGroup;
    required?: boolean;
}

const AddressField: React.FC<IProps> = ({ label, value, onChange, validationGroup, required = false }) => (
    <FormField label={label} required={required}>
        <Input value={value} onChange={onChange} required={required} validationGroup={validationGroup} />
    </FormField>
);

export default AddressField;
